<template>
  <BModal
    id="custom-field-modal"
    ref="custom-field-modal"
    modal-class="modal-width-380"
    hide-footer="hide-footer"
    @hide="handleHide"
  >
    <template slot="modal-header">
      <div
        class="modal-title"
        v-if="field.id"
      >
        {{ __('Editar Campo Customizado') }}
      </div>
      <div
        class="modal-title"
        v-else
      >
        {{ __('Novo Campo Customizado') }}
      </div>
      <button
        class="close"
        type="button"
        data-dismiss="modal"
        aria-label="Close"
        @click="$refs['custom-field-modal'].hide()"
      >
        <span aria-hidden="true"><img
          class="mb-5px"
          src="/build/icons/close@white.svg"
          width="14"
          height="13"
        ></span>
      </button>
    </template>
    <template slot="default">
      <form @submit.prevent="save()">
        <div class="form-group">
          <label for="field-description">{{ __('Título') }}</label>
          <input
            class="form-control"
            id="field-description"
            type="text"
            v-model="field.description"
            :placeholder="__('Exemplo: produto-adquirido')"
            required="required"
          >
        </div>
        <div class="form-group">
          <label for="field-identifier">{{ __('Identificador') }} (ID)</label>
          <input
            class="form-control"
            id="field-identifier"
            type="text"
            v-model="field.identifier"
            :placeholder="__('Exemplo: produto-adquirido')"
            required="required"
          >
          <p class="form-text">
            {{ __('O Identificador (ID) deve ser único, com letras e sem espaços ou acentos') }}.
            {{ __('Ele também é utilizado para enviar dados via API') }}.
          </p>
        </div>
        <div
          class="form-group"
          v-if="! fieldType"
        >
          <label for="field-identifier">Tipo</label>
          <select
            class="form-control"
            id="field-type"
            v-model="field.field_type"
          >
            <option
              :key="type.text"
              :value="type.value"
              v-for="type in types"
            >
              {{ type.text }}
            </option>
          </select>
          <div
            v-if="field.field_type === 'checkbox_unique'"
            class="warning-checkbox-unique"
          >
            <SalesflowTriangleExclamation
              color="#242424"
              :width=16
              :height="16"
            />
            <p class="warning-checkbox-unique-text">
              Esta opção utilizará o título do campo customizado como nome da label.
            </p>
          </div>
          <div
            class="form-group options"
            v-if="hasOptions"
          >
            <div
              class="input-group mb-3"
              v-for="(option, key) in field.options"
              :key="key"
            >
              <input
                class="col form-control"
                type="text"
                :placeholder="'Opção ' + (key + 1)"
                v-model="field.options[key].value"
                required="required"
              ><span
                class="input-group-text pointer danger"
                @click="removeOption(option)"
              ><span class="fa fa-times" /></span>
            </div>
            <input
              class="click-to-add"
              type="text"
              name="options"
              :placeholder="__('Clique para adicionar uma opção')"
              readonly="readonly"
              @click="addOption"
            >
          </div>
          <p
           v-if="error"
           class="error-message"
          >
            Insira no mínimo duas opções (obrigatório).
          </p>
        </div>
        <BFormCheckbox v-model="field.hidden" style="margin-bottom: 4px">
          {{ __('Não exibir este campo na tela do lead') }}
        </BFormCheckbox>
        <BFormCheckbox v-model="field.hidden_when_creating">
          {{ __('Não exibir este campo no cadastro do lead') }}
        </BFormCheckbox>
        <div class="d-flex flex-column modal-footer default-modal-footer p-0 mt-3">
          <button
            class="btn btn-primary"
            type="submit"
            :disabled="status.saving"
          >
            <span v-if="status.saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
          </button>
          <button
            class="btn pb-0"
            type="button"
            :disabled="status.saving"
            @click.prevent="closeModal()"
          >
            <u class="btn-cancel">{{ __('Cancelar') }}</u>
          </button>
        </div>
      </form>
    </template>
  </BModal>
</template>

<script>
import { BModal, BFormCheckbox } from 'bootstrap-vue';
import SalesflowTriangleExclamation from '../../components/icon/SalesflowTriangleExclamation.vue'

export default {
  components: {
    BModal,
    BFormCheckbox,
    SalesflowTriangleExclamation
  },

  props: {
    open: false,
    fieldType: null,
  },

  created () {
    this.resetForm();
  },

  data () {
    return {
      field: {
        field_type: this.fieldType,
      },
      types: [
        { text: this.__('Campo de texto'), value: 'text' },
        { text: this.__('Selecionar de uma lista'), value: 'select', options: true },
        { text: this.__('Opção única (checkbox)'), value: 'checkbox_unique' },
        { text: this.__('Marcar uma das opções'), value: 'radio', options: true, min_options: 2 },
        { text: this.__('Marcar múltiplas opções'), value: 'checkbox', options: true, min_options: 2 },
        { text: this.__('Data'), value: 'date' },
        { text: this.__('Hora'), value: 'time' },
        { text: this.__('Data e Hora'), value: 'datetime' },
        { text: this.__('E-mail'), value: 'email' },
        { text: this.__('Numérico'), value: 'number' },
      ],
      status: {
        saving: false,
      },
      error: false,
    };
  },

  watch: {
    open (newVal, oldVal) {
      if (newVal.field) {
        if(newVal.field.field_type === 'checkbox' && !newVal.field.options) {
          newVal.field.field_type = 'checkbox_unique'
        }
        this.field = newVal.field;
      }

      this.$refs['custom-field-modal'].toggle();
    },

    'field.field_type': function (newVal, oldVal) {
      if (newVal !== 'checkbox' && newVal !== 'radio') {
        this.error = false;
      }
    },
  },

  computed: {
    hasOptions () {
      const type = this.types.find((type) => type.value == this.field.field_type);

      return type ? type.options : false;
    },

    finalField() {
      if(this.field.field_type === 'checkbox_unique') {
        return {
          ...this.field,
          field_type: 'checkbox',
          options: null
        }
      }

      const fieldWithOptions = ['checkbox', 'radio', 'select']
      if(!fieldWithOptions.includes(this.field.field_type)) {
        return {
          ...this.field,
          options: null
        }
      }

      return this.field
    }
  },

  methods: {
    save () {
      this.status.saving = true;

      if(!this.validateFields(this.field)) {
        this.error = true;
        this.status.saving = false;
        return;
      }

      if (this.field.id) {
        return this.update(this.field.id);
      }

      this.store();
    },

    store () {
      this.loading = true;

      this.$http.post('/settings/field', this.finalField)
        .then(({ data }) => {
          this.closeModal({ stored: data });

          Alert.success(this.__('Campo cadastrado!'));
        })
        .catch((response) => {
          if (response.status === 422) {
            return Alert.error(this.__(response.data[Object.keys(response.data)[0]][0]));
          }

          Alert.error(this.__('Ops, não foi possível cadastrar seu campo.'));

          this.loading = false;
        })
        .finally((response) => {
          this.status.saving = false;
        });
    },

    update (id) {
      this.loading = true;
      this.$http.put(`/settings/field/${id}`, this.finalField)
        .then((response) => {
          this.closeModal({ updated: this.field });

          Alert.success(this.__('Campo atualizado!'));
        })
        .catch((response) => {
          const errors = [];
          
          if (response.status === 422) {
            Object.keys(response.data).forEach((eachError) => {
              errors.push(response.data[eachError][0]);
            })

            const uniqueErrors = [...new Set(errors)];
  
            uniqueErrors.forEach((uniqueError) => {
              return Alert.error(uniqueError);
            })
          } else {
            Alert.error(this.__('Ops, não foi possível atualizar seu campo.'));
          }
        })
        .finally((response) => {
          this.loading = false;
          this.status.saving = false;
        });
    },

    validateFields(field) {
      const requiresOptions = ['checkbox', 'radio'];
      if(requiresOptions.includes(field.field_type) && (!field.options || field.options.length < 2)) return false;
      return true;
    },

    resetForm () {
      this.field = {
        identifier: '',
        description: '',
        label: '',
        options: [],
        hidden: false,
        field_type: 'text',
      };

      this.error = false;
      this.status.saving = false;
    },

    addOption () {
      if (! this.field.options) {
        this.field.options = [];
      }

      this.field.options.push({
        value: '',
        points: '',
      });
    },

    removeOption (option) {
      this.field.options.splice(this.field.options.indexOf(option), 1);
    },

    handleHide (event) {
      if (this.open) {
        event.preventDefault();
      }

      this.closeModal();
    },

    closeModal (params = {}) {
      this.resetForm();

      this.$emit('close', params);
    },
  },
};
</script>

<style scoped>
::v-deep .modal-width-380 .modal-dialog {
  width: 409px;
}

::v-deep .modal-content {
  border: none;
}

::v-deep .modal-header {
  padding: 16px 24px;
  border-radius: 16px 16px 0 0;
}

::v-deep .modal-body {
  padding: 16px 24px 32px 24px;
  border-radius: 0 0 16px 16px;
}

.form-text {
  margin-top: 16px;
}

.form-group .options {
  margin-top: 8px;
}

::v-deep .form-control {
  border-radius: 8px;
  border: 1px solid var(--Outline-Gray-medium, #D1D1D1);
  background: var(--Neutral-White, #FFF);
  padding: 16px 12px;
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 500;
  color: var(--Colors-Font-Dark, #242424);

  option {
    color: var(--Colors-Font-Dark, #242424);
    font-family: 'Montserrat';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
}

::v-deep .form-control:focus {
  border: 1px solid var(--Outline-Gray-medium, #D1D1D1) !important;
  outline: none !important;
  box-shadow: none !important;
}

.click-to-add {
  border-radius: 8px;
  background: var(--Outline-Gray-light, #F0F0F0);
  padding: 16px;
  border: none;
  width: 100%;
  cursor: pointer;
}

.click-to-add::placeholder {
  color: var(--Font-Placeholder, #ADB1B7);
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.input-group-text {
  background-color: var(--Sales-for-whats-Outline-Medium, #D1D1D1);
  border-radius: 0 8px 8px 0;
}

.error-message {
  color: var(--Buttom-Danger, #E14E4E);
  font-family: 'Montserrat';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: -8px;
}

.btn-cancel {
  font-size: 11px;
}

.warning-checkbox-unique {
  background: var(--Extras-Purple-extra-light, #ECE7FF);
  border-radius: 8px;
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  margin-top: 8px;
  margin-bottom: 16px;

  p {
    margin-bottom: 0;
    color: var(--Font-Dark, #242424);
    font-family: 'Montserrat';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
}

::v-deep div > input[type='checkbox'] + *::before {
  border-radius: 4px;
  border: 1px solid var(--Sales-for-whats-Outline-Medium, #D1D1D1);
  background: var(--Gray-White, #FFF);
}

::v-deep .custom-control-input:active ~ .custom-control-label::before {
  border: 1px solid #8869DF !important;
  background-color: #8869DF !important;
  outline: none !important;
  box-shadow: none !important;
}

::v-deep .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none !important;
  outline: none !important;
  border: 1px solid #D1D1D1 !important;
}

::v-deep .custom-control-input:checked:focus ~ .custom-control-label::before {
  box-shadow: none !important;
  outline: none !important;
  border: 1px solid #8869DF !important;
}

::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #8869FD;
  border-color: #8869FD;
  box-shadow: none;
}

::v-deep .custom-control-label {
  margin-top: 2px;
  color: var(--Colors-Font-Gray, #71767D);
  font-family: 'Montserrat';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
